import * as React from 'react';

import styles from '../styles.module.scss';

export const ContactIsTypingIndicator: React.FunctionComponent = () => (
  <div className={styles.typingIndicator}>
    <div className={styles.typingIndicatorItem} />
    <div className={styles.typingIndicatorItem} />
    <div className={styles.typingIndicatorItem} />
  </div>
);
